export default "<div class=\"container\">\n  <div [innerHTML]=\"text\">\n  </div>\n</div>\n"